export default __webpack_public_path__ + "static/assets/info.f63499b2.svg";